export { default, CONFIRM_VIEW } from "./Confirm";
